import React from "react";
import { Download } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
export default function CapabilityStatement() {
  return <section id="capability-statement" className="w-full bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {}
          <div className="relative aspect-square md:aspect-[4/3] lg:aspect-square overflow-hidden bg-muted">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/construction_joint_bw.png" alt="Construction Joint Architectural Detail - Bottom Up Projects" className="object-cover w-full h-full grayscale contrast-125" />
          </div>

          {}
          <div className="flex justify-center lg:justify-start">
            <Card className="w-full max-w-xl rounded-sm border border-foreground/20 bg-background py-0">
              <CardContent className="p-8 md:p-12 flex flex-col items-start">
                <span className="text-sm font-bold tracking-widest uppercase text-muted-foreground mb-4">
                  Technical Specifications
                </span>
                
                <h2 className="font-default font-extrabold text-4xl md:text-5xl lg:text-6xl text-foreground leading-none mb-6 uppercase">
                  Capability<br />Statement
                </h2>
                
                <div className="font-mono text-primary text-sm md:text-base mb-10 font-medium tracking-tight">
                  File Type: PDF | Size: 4.2MB
                </div>
                
                <Button asChild size="lg" className="bg-primary text-primary-foreground hover:scale-105 transition-all duration-300 hover:shadow-md w-full sm:w-auto h-14 px-8 text-base font-bold tracking-wide">
                  <Link to="https://bottomupprojects.com.au/wp-content/uploads/2026/10/2026-BUP-Capability-Statement.pdf" newTab>
                    DOWNLOAD CAPABILITY STATEMENT
                    <Download className="ml-2 size-5" />
                  </Link>
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}